import { render } from "./InspectionEnd.vue?vue&type=template&id=0ba67107"
import script from "./InspectionEnd.vue?vue&type=script&lang=js"
export * from "./InspectionEnd.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__